// extracted by mini-css-extract-plugin
export default {"assignment":"Assignment_assignment__2G1aM"};